import React, { useRef } from 'react';
import { Html } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { useSelector } from 'react-redux';
import { mainSelector } from '../../../store/slices/main.slice';

type HotspotProps = {
    position: [number, number, number];
    onClick: () => void; // callback senza event
};

const Hotspot: React.FC<HotspotProps> = ({ position, onClick }) => {
    const meshRef = useRef<THREE.Mesh>(null);
    const { AGModal } = useSelector(mainSelector);

    // mantieni il billboard verso il centro
    useFrame(() => {
        meshRef.current?.lookAt(new THREE.Vector3(0, 0, 0));
    });

    const activate = () => {
        if (!AGModal.open) onClick(); // non forwardare l'evento
    };

    return (
        <group>
            {/* Area di hit 3D: trasparente ma raycastabile */}
            <mesh
                ref={meshRef}
                position={position}
                onPointerDown={(e) => { e.stopPropagation(); activate(); }}
                onPointerUp={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()} // evita bubble verso OrbitControls
            >
                <sphereGeometry args={[1.4, 16, 16]} />
                {/* NON usare visible={false} perché non verrebbe raycastata */}
                <meshBasicMaterial transparent opacity={0} />
            </mesh>

            {/* Overlay DOM, sopra all'Html full-screen (che ha z-index 100) */}
            <Html
                position={position}
                center
                wrapperClass="hotspot-wrapper"
                zIndexRange={[200, 2147483000]}   // sopra ad altri Html
                style={{ pointerEvents: 'auto', zIndex: 2147483000 }}
            >
                <button
                    type="button"
                    className="hotspot-btn"
                    onPointerDown={(e) => { e.stopPropagation(); activate(); }}
                    onTouchStart={(e) => { e.stopPropagation(); activate(); }}
                    onClick={(e) => { e.stopPropagation(); activate(); }} // per desktop
                    style={{
                        width: 165, height: 165, background: 'transparent', border: 0, padding: 0,
                        cursor: 'pointer', touchAction: 'manipulation'
                    }}
                >
                    <img
                        src="/images/hotspot.png"
                        alt="Hotspot"
                        style={{ maxWidth: '60%', maxHeight: '60%', objectFit: 'contain', pointerEvents: 'none' }}
                    />
                </button>
            </Html>
        </group>
    );
};

export default Hotspot;